import { render, staticRenderFns } from "./ArchiveOrders.vue?vue&type=template&id=1b7d571c&scoped=true&"
import script from "./ArchiveOrders.vue?vue&type=script&lang=js&"
export * from "./ArchiveOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b7d571c",
  null
  
)

export default component.exports